var map = {
	"./Selima.ttf": "9b8c",
	"./celestini.png": "f046",
	"./censored-chrome.jpeg": "6338",
	"./logo.png": "cf05",
	"./pp.jpeg": "5f2c",
	"./quickspeech.jpg": "7039",
	"./selima-webfont.eot": "5edb",
	"./selima-webfont.svg": "b41a",
	"./selima-webfont.ttf": "2aed",
	"./selima-webfont.woff": "5192",
	"./selima-webfont.woff2": "6ccf",
	"./stripes.png": "df93",
	"./sw.jpeg": "263d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";